module.exports = [{"id":1,"name":"Readiness & Eagerness to Learn"},{"id":2,"name":"Towards Subject Demands"},{"id":3,"name":"Towards Showing Up to Learn"},{"id":4,"name":"Towards Effort & Determination to Work"},{"id":5,"name":"Towards Teachers"},{"id":6,"name":"Towards Yourself"},{"id":7,"name":"Towards Learning"},{"id":8,"name":"Towards Institution"}]


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/perceptionslist/perceptionslist.json
// module id = 2553
// module chunks = 0